import React, { useState } from "react";
import { FaSpinner } from "react-icons/fa";
import { forgotPassword, resetPassword } from "../api"; // Correct API functions

const SellerForgotPasswordForm = ({ onResetSuccess }) => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null);
  const [isResetMode, setIsResetMode] = useState(false);

  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage(null);

    try {
      const response = await forgotPassword({ email });
      console.log('Response:', response); // Log response
      setMessage({
        type: "success",
        text: "OTP sent successfully.",
      });
      setIsResetMode(true);
    } catch (error) {
      console.error('Error:', error.response?.data || error.message); // Log error
      setMessage({
        type: "error",
        text: error.response?.data?.message || "An error occurred. Try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  

  const handleResetPasswordSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage(null);

    try {
      if (password !== confirmPassword) {
        setMessage({ type: "error", text: "Passwords do not match." });
        setIsSubmitting(false);
        return;
      }
      console.log("Sending request:", { email, otp, password });

      await resetPassword({ email, otp, password }); // Call the reset password API

      setMessage({
        type: "success",
        text: "Password reset successfully. Redirecting to login...",

      });
      
      setTimeout(onResetSuccess, 2000); // Callback to return to login form
    } catch (error) {
      setMessage({
        type: "error",
        text: error.response?.data?.message || "An error occurred. Try again.",

    });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center bg-gradient-to-r from-green-500 to-teal-500 p-4 min-h-screen">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
        <h2 className="text-2xl font-bold text-gray-700 mb-6 text-center">
          {isResetMode ? "Reset Password" : "Forgot Password"}
        </h2>
        <form
          className="space-y-4"
          onSubmit={
            isResetMode ? handleResetPasswordSubmit : handleForgotPasswordSubmit
          }
        >
          {!isResetMode && (
            <>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Email Address
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
              />
            </>
          )}
          {isResetMode && (
            <>
              <label
                htmlFor="otp"
                className="block text-sm font-medium text-gray-700"
              >
                OTP
              </label>
              <input
                type="text"
                id="otp"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP sent to your email"
                required
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
              />
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700"
              >
                New Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter new password"
                required
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
              />
              <label
                htmlFor="confirmPassword"
                className="block text-sm font-medium text-gray-700"
              >
                Confirm New Password
              </label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
                required
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
              />
            </>
          )}
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            {isSubmitting ? (
              <FaSpinner className="animate-spin mx-auto" />
            ) : isResetMode ? (
              "Reset Password"
            ) : (
              "Send OTP"
            )}
          </button>
        </form>
        {message && (
          <p
            className={`mt-4 text-center font-medium ${
              message.type === "success" ? "text-green-500" : "text-red-500"
            }`}
          >
            {message.text}
          </p>
        )}
      </div>
    </div>
  );
};

export default SellerForgotPasswordForm;
